export function hasDescriptionForLanguage(
  description: { language_id: number; name: string; description: string }[],
  languageId: number
) {
  const foundDescription = description.find((desc) => desc.language_id === languageId)
  return foundDescription && foundDescription.description.trim() !== ''
}
